import {useState} from "preact/compat";
import Cookies from 'js-cookie';

export default function useCookies(
    key,
    initialValue
) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
        if (typeof window === "undefined") {
            return initialValue;
        }

        try {
            // Get from cookie by key
            const item = Cookies.get(key);

            // Parses the stored JSON or, if none, return initialValue
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            // If error, also return initialValue
            console.error("Error while performing cookie operation:", error);

            return initialValue;
        }
    });

    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = (
        value,
        expires = 7
    ) => {
        try {
            // Allow value to be a function, so we have the same API as useState
            const valueToStore =
                value instanceof Function ? value(storedValue) : value;

            // Save state
            setStoredValue(valueToStore);

            // Save to cookies
            if (typeof window !== "undefined") {
                Cookies.set(key, JSON.stringify(valueToStore), {
                    expires
                });
            }

        } catch (error) {
            // A more advanced implementation would handle the error case
            console.error("Error while setting cookie:", error);
        }
    };
    return [storedValue, setValue];
}
